import React, { useEffect, useRef, useState } from "react";
import * as palette from "@govlaunch/palette";
import { validateEmail } from "../inputs/fieldValidation";
import { Mobile } from "@govlaunch/core";

export default function SubscribeEmbed({ attributes, element, children, onEmailSubscribe }) {
  const ref = useRef();
  const [touched, setTouched] = useState(false);
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [showSuccess, setShowSucess] = useState(false);
  const {
    title,
    description,
    titleFontSize,
    descriptionFontSize,
    textBoxWidth,
    buttonText,
    buttonTextColor,
    buttonColor,
    buttonWidth,
    buttonBorderColor,
  } = element;

  const borderColor = touched ? (validateEmail(email) ? palette.lightGray : palette.red) : palette.lightGray;

  useEffect(() => {
    setTimeout(() => {
      setError(false);
      setShowSucess(false);
    }, 10000);
  }, [error, showSuccess]);

  const errorMsg = `Unable to subscribe ${email}`;

  return (
    <div {...attributes} contentEditable={false}>
      <div
        css={{
          userSelect: "none",
          display: "none",
        }}
      >
        {children}
      </div>
      <div
        css={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
        onClick={() => ref.current.focus()}
      >
        <div
          css={{
            fontWeight: 600,
            fontSize: titleFontSize || "24px",
            textAlign: "center",
          }}
        >
          {title}
        </div>
        <Mobile>
          {(isMobile) => {
            return (
              <div
                css={{
                  width: "100%",
                  marginTop: "16px",
                  display: "flex",
                  flexDirection: isMobile ? "column" : "row",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <input
                  ref={ref}
                  type="text"
                  value={email}
                  placeholder="Email address"
                  css={{
                    padding: "8px",
                    width: isMobile ? "80%" : `${textBoxWidth}%`,
                    minWidth: "240px",
                    color: palette.darkGray,
                    border: `1px solid ${borderColor}`,
                    borderRadius: 2,
                  }}
                  onChange={(event) => {
                    setEmail(event.target.value);
                    setTouched(true);
                  }}
                />

                <div
                  css={{
                    marginTop: isMobile ? "12px" : "0px",
                    marginLeft: isMobile ? "0px" : "12px",
                    padding: "5px 16px",
                    color: buttonTextColor,
                    fontSize: 18,
                    letterSpacing: 0.6,
                    backgroundColor: buttonColor,
                    border: "1px solid",
                    borderColor: buttonBorderColor,
                    borderRadius: 2,
                    width: buttonWidth ? `${buttonWidth}%` : undefined,
                    minWidth: "160px",
                    textDecoration: "none",
                    cursor: "pointer",
                    textAlign: "center",
                    "&:hover": {
                      opacity: 0.8,
                    },
                  }}
                  onClick={async (event) => {
                    event.stopPropagation();
                    event.preventDefault();

                    if (!validateEmail(email)) {
                      return;
                    }

                    if (onEmailSubscribe) {
                      try {
                        const result = await onEmailSubscribe(email);

                        if (result) {
                          setShowSucess(true);
                        } else {
                          setError(errorMsg);
                        }
                      } catch (err) {
                        setError(errorMsg);
                      }
                    }
                  }}
                >
                  {buttonText}
                </div>
              </div>
            );
          }}
        </Mobile>
        {error && (
          <div
            css={{
              marginTop: "16px",
              fontWeight: 500,
              fontSize: "16px",
              color: palette.red,
              textAlign: "center",
            }}
          >
            {error} ⚠
          </div>
        )}
        {showSuccess && (
          <div
            css={{
              marginTop: "16px",
              fontWeight: 500,
              fontSize: "16px",
              color: palette.greenSuccess,
              textAlign: "center",
            }}
          >
            Subscribed successfully with {email} ✔
          </div>
        )}
        {description && (
          <div
            css={{
              marginTop: "32px",
              fontWeight: 500,
              fontSize: descriptionFontSize || "16px",
              textAlign: "center",
            }}
          >
            {description}
          </div>
        )}
      </div>
    </div>
  );
}
